exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[_v-28cb0326],span.beleive[_v-28cb0326]{color:#f16623!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-28cb0326&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/pages/ce-manufacturers.vue
 ** module id = 21
 ** module chunks = 0
 **/